<template>
  <BModal
    id="modal-transfer"
    ref="modal-transfer"
    hide-footer
    hide-header
    centered
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    @show="getListCard"
  >
    <ValidationObserver #default="{ invalid }">
      <BRow class="justify-center my-1 flex flex-column items-center gap-1">
        <BCol class="flex flex-col justify-center text-center mb-1">
          <div class="text-[#333333] font-semibold text-2xl mb-[5px]">
            Transfer Saldo Kartu
          </div>
          <div class="text-[#333333] text-lg">
            Pindahkan saldo antar kartu dengan
            cepat dan mudah
          </div>
        </BCol>
        <BCol>
          <BFormGroup>
            <template #label>
              <div class="text-black flex items-center">
                <span class="font-medium text-base">Kartu Tujuan</span>
                <span class="text-primary">*</span>
              </div>
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Kartu Tujuan"
              rules="required"
            >
              <VSelect
                v-model="cardTransferId"
                placeholder="Pilih kartu"
                label="card_name"
                :options="optionsCards"
                :reduce="option => option.value"
                :loading="isLoading"
              >
                <template #no-options>
                  Tidak ada kartu
                </template>
                <template #option="{ card_name }">
                  <div class="flex items center gap-2">
                    <img
                      class="w-6"
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/card.svg"
                      alt="komcard"
                    >
                    <span class="text-black">{{ card_name }}</span>
                  </div>
                </template>
              </VSelect>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
          <BFormGroup>
            <template #label>
              <div class="text-black flex items-center">
                <span class="font-medium text-base">Nominal</span>
                <span class="text-primary">*</span>
              </div>
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Nominal"
              :rules="{ required: true, minTransfer: 'transfer', maxTransfer: infoBalance.effective_balance }"
            >
              <BFormInput
                v-model="amount"
                :state="errors.length > 0 ? false:null"
                placeholder="Masukkan nominal transfer"
                @keypress="isNumber($event)"
                @input="formatCurrency"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol
          class="border rounded-lg p-1 my-2"
          style="border-color: #E2E2E2 !important"
        >
          <BPopover
            triggers="hover"
            target="popover-saldo-pending"
            placement="topRight"
          >
            Saldo ini belum dapat ditransfer, namun bisa digunakan untuk transaksi. Pihak penyedia layanan segera memprosesnya kembali ke kartu debit kamu
          </BPopover>
          <div class="flex items-center justify-between font-semibold text-black ml-1">
            <div>Saldo Komcards</div>
            <div>{{ IDR(infoBalance.balance,2,2) }}</div>
          </div>
          <div class="flex items-center justify-between  text-black ml-2">
            <div>Voucher Iklan</div>
            <div class="text-primary">
              {{ IDR(infoBalance.voucher_balance,2,2) }}
            </div>
          </div>
          <div class="flex items-center justify-between text-black ml-2">
            <div class="flex items-center gap-3">
              <div>Saldo Pending</div>
              <img
                id="popover-saldo-pending"
                src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                alt="Komerce"
                width="20"
                class="cursor-pointer"
              >
            </div>
            <div class="text-primary">
              {{ IDR(infoBalance.hold_balance,2,2) }}
            </div>
          </div>
          <div class="flex items-center justify-between  text-black ml-2">
            <div>Saldo Mengendap</div>
            <div class="text-primary">
              {{ IDR(infoBalance.balance_settle,2,2) }}
            </div>
          </div>
          <div class="flex items-center justify-between font-semibold text-black mt-1 border-[#FEF2CD] bg-[#FFF8E1] rounded-lg p-1">
            <div>Saldo yang bisa ditransfer</div>
            <div class="font-semibold">
              {{ IDR(infoBalance.effective_balance,2,2) }}
            </div>
          </div>
        </BCol>
      </BRow>
      <BRow class="mb-1">
        <BCol cols="6">
          <BButton
            variant="outline-primary"
            block
            @click="
              $bvModal.hide('modal-transfer')
              cardTransferId = null
              amount = null
            "
          >
            Batal
          </BButton>
        </BCol>
        <BCol cols="6">
          <BButton
            :disabled="invalid"
            :variant="invalid ? 'secondary' : 'primary'"
            type="submit"
            block
            @click.prevent="onUpdate"
          >
            Transfer Saldo
          </BButton>
        </BCol>
      </BRow>
    </ValidationObserver>
  </BModal>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import VSelect from 'vue-select'
import { required } from '@validations'
import { newAxiosIns } from '@/libs/axios'
import { IDRWithoutLbl, IDR } from '@/libs/currency'
import { isNumber } from '@/libs/helpers'

extend('minTransfer', {
  validate: value => {
    const minTransfer = 10000
    const amount = parseFloat(value.replace(/[Rp.p]/g, ''))
    return amount >= minTransfer
  },
  message: () => {
    const minTransfer = 10000
    return `Minimal ${IDR(minTransfer)}`
  },
})

extend('maxTransfer', {
  validate: (value, args) => {
    const maxTransfer = args[0]
    const amount = parseFloat(value.replace(/[Rp.p]/g, ''))
    return amount <= maxTransfer
  },
  message: (field, args) => {
    const maxTransfer = args[0]
    return `Saldo yang bisa di transfer sejumlah ${IDR(maxTransfer)}`
  },
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VSelect,
  },
  props: {
    infoBalance: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isNumber,
      required,
      cardTransferId: null,
      optionsCards: [],
      isLoading: false,
      isLoadingTransfer: false,
      amount: null,
      IDRWithoutLbl,
      IDR,
    }
  },
  computed: {
    balanceDifference() {
      return this.kompoints.balance - this.voucher.kompoint_fee
    },
  },
  methods: {
    async getListCard() {
      this.isLoading = true
      const url = '/komcards/api/v1/card/list?levels=platinum'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res
          const tempData = data.data.map(item => ({
            ...item,
            value: item.id,
            card_name: `${item.name} *${this.splitCardNumber(item.card_number)}`,
          }))

          const filteredData = tempData.filter(item => item.id !== Number(this.id))

          this.optionsCards = filteredData
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          this.$toast_error({ message: 'Gagal mendapatkan daftar kartu' })
        })
    },
    onUpdate() {
      this.$bvModal.show('modal-verify-pin')
      this.$bvModal.hide('modal-transfer')
      this.updateInput()
    },
    updateInput() {
      this.$emit('update-payload-transfer', {
        amount: this.amount,
        cardTransferId: this.cardTransferId,
      })
    },
    splitCardNumber(number) {
      return number.split(' ').pop()
    },
    formatCurrency(value) {
      const currency = value.replace(/[Rp. ]/g, '')
      const format = new Intl.NumberFormat('id-ID').format(currency)
      this.amount = `Rp ${format}`
    },
    onReset() {
      this.amount = null
      this.cardTransferId = null
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
